export default __webpack_public_path__ + "static/media/line-dashed.04f000f3.svg";